import type { PortalConfig } from 'context/PortalConfigContext'

export const getPortalDomain = (
  portalConfig:
    | Pick<PortalConfig, 'domain' | 'epilot_domain'>
    | undefined
    | null
): string | undefined => portalConfig?.domain || portalConfig?.epilot_domain
